import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { useModal } from "../../../../../MyContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactForm = () => {
  const { showContactModal, openModal, closeModal } = useModal();
  const triggeredRef = useRef(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    website: "",
    countryCode: "+91",
    contact: ""
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200 && !triggeredRef.current) {
        triggeredRef.current = true;
        openModal();
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.email || !formData.contact) {
      toast.warning("Please fill all required fields");
      return;
    }

    const payload = {
      fullname: formData.fullName,
      email: formData.email,
      website: formData.website,
      contact: `${formData.countryCode}${formData.contact}`
    };

    try {
      setLoading(true);

      const response = await fetch(
        "https://auth.seobix.com/api/Auth/InsertLeads",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();

      if (data?.status === "0") {
        toast.success(
          data?.result?.[0]?.message || "Request submitted successfully"
        );

        setTimeout(() => closeModal(), 1500);

        setFormData({
          fullName: "",
          email: "",
          website: "",
          countryCode: "+91",
          contact: ""
        });
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Server error. Please try later.");
    } finally {
      setLoading(false);
    }
  };

  return (
<> 
       <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />

    <Modal
      show={showContactModal}
      onHide={closeModal}
      centered
      size="md"
      backdropClassName="transparent-backdrop"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fs-6 fw-semibold">
          Please fill out the form below and we will ensure a personalised demo
          catering to your requirements.
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-4">
        <Form onSubmit={handleSubmit} noValidate>
          {/* Full Name */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              Full Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
            />
          </Form.Group>

          {/* Email */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              Work Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="name@company.com"
            />
          </Form.Group>

          {/* Website */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-medium">
              Website Link <span className="text-muted">(Optional)</span>
            </Form.Label>
            <Form.Control
              type="url"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="https://yourwebsite.com"
            />
          </Form.Group>

          {/* Contact */}
          <Form.Group className="mb-4">
            <Form.Label className="fw-medium">
              Contact Number <span className="text-danger">*</span>
            </Form.Label>

            <InputGroup>
              <Form.Select
                style={{ maxWidth: "110px" }}
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
              >
                <option value="+91">+91</option>
                <option value="+1">+1</option>
                <option value="+44">+44</option>
                <option value="+61">+61</option>
              </Form.Select>

              <Form.Control
                type="tel"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                placeholder="Enter your number"
              />
            </InputGroup>
          </Form.Group>

          <Button
            type="submit"
            className="w-100 py-2 fw-medium bg-purple"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Request Demo"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ContactForm;
